import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { ChatWidget } from "@/components/ChatWidget";
import { AuthProvider } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import Admin from "@/pages/Admin";
import Founder from "@/pages/Founder";
import Course from "@/pages/Grants";
import Legal from "@/pages/Legal";
import ResetPassword from "@/pages/ResetPassword";
import Strategizer from "@/pages/Strategizer";
import Compare from "@/pages/Compare";
import ServiceDetail from "@/pages/ServiceDetail";
import PackageDetail from "@/pages/Services";
import MyPlan from "@/pages/MyPlan";
import Explore from "@/pages/Services";
import Grants from "@/pages/Grants";
import Marketplace from "@/pages/Marketplace";
import ProductDetail from "@/pages/ProductDetail";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentStatus";

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<Landing />} />
                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route path="/admin" element={<Admin />} />
                        <Route path="/founder" element={<Founder />} />
                        <Route path="/learn" element={<Grants />} />
                        <Route path="/grants" element={<Grants />} />
                        <Route path="/marketplace" element={<Marketplace />} />
                        <Route path="/legal/:doc" element={<Legal />} />
                        <Route path="/reset-password" element={<ResetPassword />} />
                        <Route path="/strategizer" element={<Strategizer />} />
                        <Route path="/compare" element={<Compare />} />
                        <Route path="/services/:slug" element={<ServiceDetail />} />
                        <Route path="/packages/:slug" element={<Explore />} />
                        <Route path="/services" element={<Explore />} />
                        <Route path="/my-plan" element={<MyPlan />} />
                        <Route path="/explore" element={<Explore />} />
                        <Route path="/products/:id" element={<ProductDetail />} />
                        <Route path="/payment/success" element={<PaymentSuccess />} />
                        <Route path="/payment/cancel" element={<PaymentCancel />} />
                    </Routes>
                    <ChatWidget />
                </BrowserRouter>
                <Toaster position="top-right" richColors />
            </AuthProvider>
        </div>
    );
}

export default App;
